export default {
  declaracaoImportacaoTableHeaders: [
    {
      text: 'produto',
      value: 'produto',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'produto',
      },
    },
    {
      text: 'numeroDI',
      value: 'codigoDI',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'codigoDI',
      },
    },
    {
      text: 'NCM',
      value: 'ncm',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'ncm',
      },
    },
    {
      text: 'pesoLiquido',
      value: 'pesoLiquido',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'pesoLiquido',
      },
    },
    {
      text: 'quantidade',
      value: 'quantidade',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'quantidade',
      },
    },
    {
      text: 'valor',
      value: 'valor',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'valor',
      },
    },
    {
      text: 'moeda',
      value: 'moedaInvoice',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'moedaInvoice',
      },
    },
    {
      text: 'referenciaCliente',
      value: 'referenciaCliente',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'referenciaCliente',
      },
    },
    {
      text: 'referenciaTrust',
      value: 'referenciaTrust',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'referenciaTrust',
      },
    },
    {
      text: 'dataRegistro',
      value: 'dataRegistroDI',
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'dataRegistroDI',
      },
    },
  ],
  declaracaoImportacaoTableItems: [],
  itemsDeclaracaoImportacaoByCodigoDI: [],
  filtros: {
    termo: '',
    page: 1,
    perPage: 20,
    order: 'dataRegistroDI',
    direcao: 'DESC',

    descricaoCompleta: '',
    produto: '',
    codigoDI: '',
    ncm: '',
    pesoLiquido: '',
    quantidade: '',
    valor: '',
    moedaInvoice: '',
    referenciaCliente: '',
    referenciaTrust: '',
    dataRegistroDI: '',
  },
};
